import { getOr } from 'lodash/fp'

import middlewareSvc from 'core/service/advisorzone-middleware/request-wrapper'
import { requestWrapper } from 'e-submission/domain/data'

export const RETRIEVE_POLICY_LIST_PATH = 'retrieve/policies'

export const retrievePolicyListByIdNo = (idType, idNo, user) => {
  const params = { idType, idNo }
  return requestWrapper
    .postRequestWithoutGlobalError(RETRIEVE_POLICY_LIST_PATH, user, params)
    .then(({ data }) => {
      const policyList = getOr([], 'RetrievePolicyListResponse.policy', data)
      return { RetrievePolicyListResponse: { policy: policyList } }
    })
    .catch((err) => {
      return { RetrievePolicyListResponse: { policy: [] } }
    })
}

export const retrievePolicyDetails = ({ policyNo, policyEffectiveDate, policyExpirationDate }, user) => {
  const params = {
    policyNumber: policyNo,
    policyEffectiveDate,
    policyEffectiveToDate: policyExpirationDate,
  }
  return requestWrapper
    .postRequestWithoutGlobalError(`${RETRIEVE_POLICY_LIST_PATH}/details`, user, params)
    .then(({ data }) => data)
    .catch((err) => {
      throw new Error('Failed to retrieve policy details')
    })
}
